import React from 'react';
import { ResponsiveValue } from '../../theme/types';
import Box from '../Box';

export interface VisibleProps {
  display: ResponsiveValue<'block' | 'none'>;
  children: React.ReactNode;
}

const Visible: React.FC<VisibleProps> = React.memo(function Visible(props) {
  return <Box display={props.display}>{props.children}</Box>;
});

export default Visible;
